import { FC } from 'react';

import { GiftSellerTabbedPage } from '../components/GiftSellerTabbedPage';
import { GiftCouponRedemptionListPage } from './GiftCouponRedemptionListPage';
import { GiftDeliveredHistoryPage } from './GiftDeliveredHistoryPage';

/**
 * 발송 관리 — 발송 대기(교환 신청분 발송처리) + 발송내역 조회(날짜별 완료분)를 한 메뉴로.
 * 구 경로 /coupon-redemption, /delivered-history(?date=) 는 라우터에서 탭으로 넘긴다.
 */
export const GiftSendManagePage: FC = function GiftSendManagePage() {
  return (
    <GiftSellerTabbedPage
      tabs={[
        {
          key: 'pending',
          label: '발송 대기',
          element: <GiftCouponRedemptionListPage />,
        },
        {
          key: 'history',
          label: '발송내역 조회',
          element: <GiftDeliveredHistoryPage />,
        },
      ]}
    />
  );
};
